document.addEventListener('DOMContentLoaded', function () {
    const sliders = document.querySelectorAll('.wp-block-suzugaku-original-lp-slider-graduates .slick-slider');
    sliders.forEach((slider) => {
        // 基本のオプションを定義
        let slickOptions = {
            // autoplay: true,
            arrows: true,
            infinite: true,
            pauseOnHover: false,
            dots: true,
        };

        // 画面幅が1024pxより大きい場合にオプションを追加
        if (window.innerWidth > 796) {
            slickOptions.centerMode = true;
            slickOptions.centerPadding = "25%";
        }

        // slickを初期化
        jQuery(slider).slick(slickOptions);
    });
});
